import React, { useState } from "react";
import {
  Grid,
  RadioGroup,
} from "@material-ui/core";
import { setAcquirerSelected } from "../../actions";
import { getActiveAcquirers } from "../../helper/Acquirers";
import { useDispatch, useSelector } from "react-redux";
import CardAcquirerItem from "../CardAcquirerItem";

function AcquirerItem(props) {
  const dispatch = useDispatch();
  const [adquirentes, setAdquirentes] = useState(null);
  const [acquirer, setAcquirerSelectedState] = useState({});
  const acquirerSelected = useSelector(
    (state) => state.cardDebitState.acquirerSelected
  );

  function handleChange(event) {
    setAcquirerSelectedState(checkImgFromAcquirer(event.target.value));
    dispatch(setAcquirerSelected(checkImgFromAcquirer(event.target.value)));
  }

  React.useEffect(() => {
    getActiveAcquirers().then((response) => {
      setAdquirentes(response);
    });
  }, []);

  React.useEffect(() => {
    dispatch(setAcquirerSelected(acquirer));
  }, [acquirer, acquirerSelected, dispatch]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function checkImgFromAcquirer(acquirerInitials) {
    const acquirerSelected = adquirentes.filter(acquirer => acquirer.Sigla === acquirerInitials);
    return acquirerSelected[0]
  }

  function checkImgType(Logotipo) {
    if (Logotipo !== null) {
      var index = 0;
      index = Logotipo && Logotipo.indexOf(",");
      if (index > 0 && index !== undefined) {
        var tag = Logotipo.substring(0, index + 1);
        return Logotipo.replace(tag, "");
      }
      return Logotipo;
    }
  }
  
  return (
    <div>
      <RadioGroup
        aria-label="Adquirente"
        style={{ display: "flex", flexDirection: "row" }}
        onChange={handleChange}
      >
        {adquirentes !== null
          ? adquirentes.map((acquirer) => {
              return (
                <Grid
                  key={acquirer.Id}
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  style={{ flexBasis: "17%" }}
                  elevation={0}
                >
                  <CardAcquirerItem
                    src={`data:image/png;base64,${checkImgType(
                      acquirer.Logotipo
                    )}`}
                    acquirer={acquirer}
                    staticLogoDam={props.staticLogoDam}
                  />
                </Grid>
              );
            })
          : null}
      </RadioGroup>
    </div>
  );
}

export default AcquirerItem;